<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          <!-- {{ dataId ? '查看' : '新增' }}特设费用 -->
          批量新增
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  标准名称
                </th>
                <td colspan="3">
                  <el-input type="textarea" :rows="1" style="" v-model="formData.settleStandardBatchDTO.name" :maxlength="30" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  结算标准
                </th>
                <td>
                  <!-- <el-input type="number" oninput="if(value<0||value>9999)value=0" autocomplete="off"
                            v-model="formData.price" clearable/> -->
                  <el-input type="text" autocomplete="off" style="width: 165px;" v-model="formData.settleStandardBatchDTO.price" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  红利
                </th>
                <td>
                  <!-- <el-input type="number" oninput="if(value<0||value>9999)value=0" autocomplete="off"
                            v-model="formData.price" clearable/> -->
                  <el-input type="text" autocomplete="off" style="width: 165px;" v-model="formData.settleStandardBatchDTO.bonusFee" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>有效时间
                </th>
                <td>
                  <el-date-picker class="current-date-picker"
                                  v-model="formData.settleStandardBatchDTO.date"
                                  type="daterange"
                                  align="right"
                                  unlink-panels
                                  range-separator="-"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  value-format='yyyy-MM-dd'>
                  </el-date-picker>
                </td>
                <!-- <th>
                  <em class="f-red">*</em>
                  计价
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.unit" clearable/>
                </td> -->
              </tr>


              </tbody>
            </table>
          </div>

          <div style="">
            <div class="d-item">
              <div class="title first" style="display: flex;flex-direction: row;
    justify-content: space-between;">
                <b>必要条件</b>
                <!-- <div class="item-button">
                  <el-button type="primary" class="button-sty btn_zdy" @click="showItemPop=true">
                    <i class="el-icon-plus"></i>
                    产品
                  </el-button>&nbsp;
                  <el-button
                             type="primary" class="button-sty btn_zdy" @click="handleDeleteItemList">
                    <i class="el-icon-delete"></i>
                    批量删除
                  </el-button>
            </div> -->
              </div>

              <div style="display: flex; width: 100%; ">

                <div class="current-info">
                  <!--保修类型-->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true, padding: 0, keyField: 'id', }"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    :checkbox-config="{checkRowKeys: selectedGuaranteeTypeIdList, highlight: false}"
                    :data="formData.guaranteeTypeList"
                    @checkbox-change="guaranteeTypeSelectChangeEvent"
                    @checkbox-all="guaranteeTypeSelectChangeEvent"
                  >
                    <vxe-column type="checkbox" field="id" width="40"></vxe-column>
                    <vxe-column field="type" width="120" title="保修类型"></vxe-column>
                  </vxe-table>
                </div>

                <div class="current-info" style="width:240px;">
                  <!-- 服务类型 -->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true,padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    :tree-config="{transform: true}"
                    :checkbox-config="{labelField: 'name', checkRowKeys: selectedServiceTypeIdList}"
                    :data="formData.serviceTypeList"
                    @checkbox-change="serviceTypeSelectChangeEvent"
                    @checkbox-all="serviceTypeSelectChangeEvent"
                  >
                    <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                    <vxe-column field="serviceTypeName" width="150" title="服务类型"></vxe-column>
                  </vxe-table>
                </div>

                <div class="current-info" style="width:240px;">
                  <!-- 购买渠道 -->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true,padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    :tree-config="{transform: true}"
                    :checkbox-config="{labelField: 'name', checkRowKeys: selectedBasBuyChannelList}"
                    :data="formData.basBuyChannelList"
                    @checkbox-change="buyChannelChangeEvent"
                    @checkbox-all="buyChannelChangeEvent"
                  >
                    <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                    <vxe-column field="buyChannelName" width="150" title="购买渠道"></vxe-column>
                  </vxe-table>
                </div>

                <div class="current-info">
                  <!--品牌-->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    ref="brand"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true, padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    :checkbox-config="{labelField: 'name', checkRowKeys: selectedBrandIdList ,checkMethod: checCheckboxMethod}"
                    :data="formData.snCompanyBrandList"
                    @checkbox-change="brandSelectChangeEvent"
                    @checkbox-all="brandSelectChangeEvent"
                  >
                    <vxe-column type="checkbox" width="40"></vxe-column>
                    <vxe-column field="brandName" width="120" title="品牌"></vxe-column>
                  </vxe-table>
                </div>

                <div class="current-info" style="width:240px;">
                  <!--产品类型-->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    ref="category"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true,padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    :tree-config="{transform: true}"
                    :checkbox-config="{labelField: 'name', checkRowKeys: selectedItemCategoryIdList,checkMethod: checCheckboxMethod}"
                    :data="formData.itemCategoryList"
                    @checkbox-change="itemCategorySelectChangeEvent"
                    @checkbox-all="itemCategorySelectChangeEvent"
                  >
                    <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                    <vxe-column field="categoryName" width="150" title="产品类型"></vxe-column>
                  </vxe-table>
                </div>

              </div>

            </div>

          </div>
          <div>
            <div class="d-item">
              <div class="title first" style="display: flex;flex-direction: row;
    justify-content: space-between;">
                <b>可选条件</b>
                <!-- <div class="item-button">
                  <el-button type="primary" class="button-sty btn_zdy" @click="showItemPop=true">
                    <i class="el-icon-plus"></i>
                    产品
                  </el-button>&nbsp;
                  <el-button
                             type="primary" class="button-sty btn_zdy" @click="handleDeleteItemList">
                    <i class="el-icon-delete"></i>
                    批量删除
                  </el-button>
            </div> -->
              </div>

              <div style="display: flex; width: 100%; ">

                <div class="current-info" style="width:240px;">
                  <div class="item-button" style="visibility: hidden;">
                    <el-button type="primary" class="button-sty btn_zdy" @click="showItemPop=true">
                      <i class="el-icon-plus"></i>
                      产品
                    </el-button>&nbsp;
                    <el-button
                      type="primary" class="button-sty btn_zdy" @click="handleDeleteItemList">
                      <i class="el-icon-delete"></i>
                      批量删除
                    </el-button>
                  </div>
                  <!--产品类型-->
                  <vxe-table
                    class="mytable-scrollbar"
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true, padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="260" :column-config="{ resizable: true }"
                    resizable
                    row-id="id"
                    :checkbox-config="{labelField: 'name', checkRowKeys: selectSiteTypeOption}"
                    :data="siteTypeOption"
                    @checkbox-change="siteTypeSelectChangeEvent"
                    @checkbox-all="siteTypeSelectChangeEvent"
                  >
                    <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                    <vxe-column field="label" width="150" title="网点性质"></vxe-column>
                    <!--                    <vxe-column field="categoryName" width="150" title="网点等级">-->
                    <!--                      <vxe-select v-model="formData.siteLevelId" placeholder="网点等级" style="width: 165px;">-->
                    <!--                        <el-option v-for="item in siteLevelOption" :key="item.value" :label="item.label"-->
                    <!--                                   :value="item.value"/>-->
                    <!--                      </vxe-select>-->
                    <!--                    </vxe-column>-->
                  </vxe-table>
                </div>

                <div class="current-info">
                  <!--网点-->
                  <div class="item-button">
                    <el-button type="" class="button-sty btn_zdy" @click="showPreconditionDialog2=true">
                      <i class="el-icon-plus"></i>
                      网点服务
                    </el-button>&nbsp;
                    <el-button
                      type="primary" class="button-sty btn_zdy" @click="handleDeleteItemList1">
                      <i class="el-icon-delete"></i>
                      批量删除
                    </el-button>
                  </div>
                  <vxe-table ref="filterTable" height="260"
                             class="table_item pic_item mytable-scrollbar"
                             :column-config="{ resizable: true }"
                             style="width: 100%;"
                             :stripe="true"
                             :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{height: 30,isHover: true,padding: 0,}"
                             :row-style="{ fontSize: '12px',  }"
                             show-overflow
                             :data="siteName"
                             @checkbox-all="siteNameSelectChangeEvent1"
                             @checkbox-change="siteNameSelectChangeEvent1"
                  >
                    <vxe-column type="checkbox" width="40"/>
                    <vxe-column field="userMobile" title="网点账号" width="120"/>
                    <vxe-column field="userName" title="网点名称" width="80"/>
                    <vxe-column title="操作" width="60">
                      <template #default="{row}">
                        <div @click="handleDeleteItem1(row.id)">
                          <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                      popper-class="tooltip-skin">
                            <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>



                <div class="current-info">
                  <div class="item-button">
                    <el-button type="primary" class="button-sty btn_zdy" @click="showItemPop=true">
                      <i class="el-icon-plus"></i>
                      产品
                    </el-button>&nbsp;
                    <el-button
                      type="primary" class="button-sty btn_zdy" @click="handleDeleteItemList">
                      <i class="el-icon-delete"></i>
                      批量删除
                    </el-button>
                  </div>
                  <vxe-table ref="filterTable" height="260"
                             class="table_item pic_item mytable-scrollbar"
                             :column-config="{ resizable: true }"
                             style="width: 100%;"
                             :stripe="true"
                             :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{height: 30,isHover: true,padding: 0,}"
                             :row-style="{ fontSize: '12px',  }"
                             show-overflow
                             :data="itemList"
                             @checkbox-all="itemSelectChangeEvent"
                             @checkbox-change="itemSelectChangeEvent"
                  >
                    <vxe-column type="checkbox" width="40"/>
                    <vxe-column field="itemCode" title="产品编码" width="120"/>
                    <vxe-column field="itemName" title="产品名称" width="80"/>
                    <vxe-column title="操作" width="60">
                      <template #default="{row}">
                        <div @click="handleDeleteItem(row.id)">
                          <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                      popper-class="tooltip-skin">
                            <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </el-form>
    <item-pop v-if="showItemPop"
              :visiable.sync="showItemPop"

              @confirm="commitSelectedRow"
              :excludeList="itemList"
    />
    <sitePop v-if="showPreconditionDialog2"
             :visiable.sync="showPreconditionDialog2"
             @confirm="commitSelectedRow1"
             :excludeList="siteName"
    />
  </div>
</template>
<script>

import api from "@/api/projectApi";
import itemPop from "@/components/pop/checkboxItemPop.vue"
import sitePop from '@/views/dialogCommon/duoradioSiteDialog.vue';
import {dictType, loadDictData} from "@/config/dictType";

export default {
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    itemPop, sitePop
  },
  data() {
    return {
      initDataUrl: '/basic/sfSettleStandard/init',
      addsDataUrl: '/basic/sfSettleStandard/adds',
      showGuaranteeTypeList: true,
      showItemPop: false,
      showPreconditionDialog2: false,
      showEdit: false,
      activeName: 'first',
      isEdit: false,
      dataId: '',
      formData: {
        id: '',  // 主键id,自动新增
        createBy: '',  // 创建人
        createTime: '',  // 创建时间
        feeType: 1,  // 类型:1向公司申请;2向用户收取
        name: '',  // 特设费用名称
        price: 0,  // 金额
        unit: '',  // 计价单位
        stat: 0,  // 启用:0禁用；1启用
        itemCategoryList: [],
        serviceTypeList: [],
        snCompanyBrandList: [],
        basBuyChannelList:[],
        guaranteeTypeList: [],
        settleStandardBatchDTO: {
          guaranteeTypes: null,
          serverTypeIds: null,
          buyChannelIds: null,
          brandIds: null,
          smallCategoryIds: null,
          name: '',  // 特设费用名称
          price: 0,  // 金额
          bonusFee: 0, //红利
          date: null, //有效时间
          siteTypeIds: null,
          siteIds : null,
          itemIds : null,
          isAllServerType : false,
          isAllBuyChannel : false,
          isAllBrand : false,
          isAllCategory : false
        }
      },
      selectedBrandIdList: [],
      selectedItemCategoryIdList: [],
      selectedServiceTypeIdList: [],
      selectedGuaranteeTypeIdList: [],
      selectedBasBuyChannelList: [],

      itemList: [],
      itemIdList: [],
      selectedItemList: [],
      siteName: [],
      siteIdList: [],
      selectedSiteName: [],

      siteTypeOption: [],
      selectSiteTypeOption: [],
    }
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId
  },
  mounted() {
    this.getData();
    this.loadDictData()
  },

  methods: {

    // 当产品中有值的时候品牌和产品分类不能勾选
    checCheckboxMethod(){
      if (this.itemList.length > 0){
        return false;
      }else{
        return true;
      }
    },

    // 产品批量删除
    handleDeleteItemList() {
      if (this.selectedItemList.length === 0) {
        this.$message.warning('请先勾选产品')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.selectedItemList.forEach(item0 => {
            this.itemList = this.itemList.filter(item => item.id !== item0)
            console.log(this.itemList, '产品集合')
          })
          this.selectedItemList = [];//删除后清空
        })
      }
    },

    // 产品删除
    handleDeleteItem(id) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.itemList = this.itemList.filter(item => item.id !== id)
        console.log(this.itemList, '产品集合')
      })
    },

    // 产品复选框
    itemSelectChangeEvent({records}) {
      this.selectedItemList = records.map(item => item.id)
      console.log('产品选中', this.selectedItemList)
    },

    // 产品选中
    commitSelectedRow(data) {
      console.log(data, '产品选中')
      let temp = this.itemList
      if (temp.length === 0) {
        this.itemList = data
      } else {
        data.forEach(item => {
          temp.push(item)
        })
      }

      // 选中产品后要清空品牌选项和产品类型选项
      this.selectedBrandIdList = [];
      this.selectedItemCategoryIdList = [];
      this.$refs.brand.clearCheckboxRow()
      this.$refs.category.clearCheckboxRow()

      console.log(this.itemList, '产品集合')
    },


    // 网点批量删除
    handleDeleteItemList1() {
      if (this.selectedSiteName.length === 0) {
        this.$message.warning('请先勾选网点')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.selectedSiteName.forEach(item0 => {
            this.siteName = this.siteName.filter(item => item.id !== item0)
          })
          this.selectedSiteName = [];
        })
      }
    },

    // 网点删除
    handleDeleteItem1(id) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.siteName = this.siteName.filter(item => item.id !== id)
      })
    },

    // 网点复选框
    siteNameSelectChangeEvent1({records}) {
      this.selectedSiteName = records.map(item => item.id)
      console.log('网点选中', this.selectedSiteName)
    },

    commitSelectedRow1(data) {
      console.log(data, '网点选中')
      let temp = this.siteName
      if (temp.length===0){
        this.siteName=data
      }else {
        data.forEach(item=>{
          temp.push(item)
        })
      }
    },

    // 保修类型复选框
    guaranteeTypeSelectChangeEvent({records}) {
      this.selectedGuaranteeTypeIdList = records.map(item => item.id)
      console.log('保修类型选中', this.selectedGuaranteeTypeIdList)
    },

    // 购买渠道复选框
    buyChannelChangeEvent({records}) {
      this.selectedBasBuyChannelList = records.map(item => item.id)
      console.log('购买渠道选中', this.selectedBasBuyChannelList)
      if (records.length === this.formData.basBuyChannelList.length){
        this.formData.settleStandardBatchDTO.isAllBuyChannel = true;
        console.log("全选购买渠道");
      }else{
        this.formData.settleStandardBatchDTO.isAllBuyChannel = false;
      }
    },

    // 品牌复选框
    brandSelectChangeEvent({records}) {
      this.selectedBrandIdList = records.map(item => item.id)
      console.log('品牌选中', this.selectedBrandIdList)
      if (records.length === this.formData.snCompanyBrandList.length){
        this.formData.settleStandardBatchDTO.isAllBrand = true;
        console.log("全选品牌");
      }else {
        this.formData.settleStandardBatchDTO.isAllBrand = false;
      }
    },
    // 网点性质复选框
    siteTypeSelectChangeEvent({records}) {
      this.selectSiteTypeOption = records.map(item => item.id)
      console.log('网点性质选中', this.selectSiteTypeOption)
    },
// 加载数据字典中网点性质
    loadDictData() {
      loadDictData(dictType.siteQuality).then(res => {
        this.siteTypeOption = []
        res.data.data.forEach(item => {
          this.siteTypeOption.push({
            label: item.label,
            id: item.id
          })
        })
      })
    },
    // 服务品类复选框
    itemCategorySelectChangeEvent({records}) {
      // 拿到所有id
      let temp = records.map(item => item.id)

      // 获取有子类的父id
      let parentTemp = new Set()
      records.forEach(item => {
        if (item.parentId != 0) {
          parentTemp.add(item.parentId)
        }
      })

      // 去除有子类的父id
      let temp1 = []
      temp.forEach(item => {
        if (!parentTemp.has(item)) {
          temp1.push(item)
        }
      })
      this.selectedItemCategoryIdList = temp1
      console.log('选中的服务品类id', temp1)

      if (records.length === this.formData.itemCategoryList.length){
        this.formData.settleStandardBatchDTO.isAllCategory = true;
        console.log("全选产品类型");
      }else{
        this.formData.settleStandardBatchDTO.isAllCategory = false;
      }

    },

    // 服务类型复选框
    serviceTypeSelectChangeEvent({records}) {
      // 拿到所有id
      let temp = records.map(item => item.id)

      // 获取有子类的父id
      let parentTemp = new Set()
      records.forEach(item => {
        if (item.parentId != 0) {
          parentTemp.add(item.parentId)
        }
      })

      // 去除有子类的父id
      let temp1 = []
      temp.forEach(item => {
        if (!parentTemp.has(item)) {
          temp1.push(item)
        }
      })
      this.selectedServiceTypeIdList = temp1

      if (records.length === this.formData.serviceTypeList.length){
        this.formData.settleStandardBatchDTO.isAllServerType = true;
        console.log("全选服务类型");
      }else{
        this.formData.settleStandardBatchDTO.isAllServerType = false;
      }

    },


    // 新增数据时初始化
    init() {
      this.$http({
        url: this.initDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        let data = res.data.data
        console.log("initData--->",data);
        this.formData.itemCategoryList = data.itemCategoryList
        this.formData.serviceTypeList = data.serviceTypeList
        this.formData.snCompanyBrandList = data.snCompanyBrandList
        this.formData.basBuyChannelList = data.basBuyChannelList
        this.formData.guaranteeTypeList = [{id: '1', type: '保内'}, {id: '2', type: '保外'}]
      })
    },

    // 回显
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        console.log("1111");
        this.isEdit = true;
        this.$http({
          url: api.sfSpecialFeeSubject.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data || {}
          this.formData = data

          this.setListData(data)

          // this.loadProductOption1()
        })
      } else {
        console.log("2222");
        this.init()
      }
    },

    saveData() {

      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {

            if(this.formData.settleStandardBatchDTO.name == null || this.formData.settleStandardBatchDTO.name === ''){
              this.$message.warning('请填写标准名称')
              return
            }

            if(this.formData.settleStandardBatchDTO.price == null || this.formData.settleStandardBatchDTO.price === ''){
              this.$message.warning('请填写结算标准')
              return
            }

            if(this.formData.settleStandardBatchDTO.bonusFee == null || this.formData.settleStandardBatchDTO.bonusFee === ''){
              this.$message.warning('请填写红利')
              return
            }

            if(this.formData.settleStandardBatchDTO.date == null || this.formData.settleStandardBatchDTO.date === ''){
              this.$message.warning('请填写有效时间')
              return
            }

            if (this.selectedGuaranteeTypeIdList != null && this.selectedGuaranteeTypeIdList.length !== 0) {
              let temp = this.selectedGuaranteeTypeIdList.sort()
              this.formData.settleStandardBatchDTO.guaranteeTypes = temp.join(';')
            } else {
              this.$message.warning('请选择保修类型')
              return
            }

            if (this.selectedServiceTypeIdList != null && this.selectedServiceTypeIdList.length !== 0) {
              let temp = this.selectedServiceTypeIdList.sort()
              this.formData.settleStandardBatchDTO.serverTypeIds = temp.join(';')
            } else {
              this.$message.warning('请选择服务类型')
              return
            }

            if (this.selectedBasBuyChannelList != null && this.selectedBasBuyChannelList.length !== 0) {
              let temp = this.selectedBasBuyChannelList.sort()
              this.formData.settleStandardBatchDTO.buyChannelIds = temp.join(';')
            } else {
              this.$message.warning('请选择购买渠道')
              return
            }

            //当没有选择产品的时候，品牌和产品类型是必填
            if (this.itemList == null || this.itemList.length === 0){

              if (this.selectedBrandIdList != null && this.selectedBrandIdList.length !== 0) {
                let temp = this.selectedBrandIdList.sort()
                this.formData.settleStandardBatchDTO.brandIds = temp.join(';')
              } else {
                this.$message.warning('请选择品牌')
                return
              }

              if (this.selectedItemCategoryIdList != null && this.selectedItemCategoryIdList.length !== 0) {
                let temp = this.selectedItemCategoryIdList.sort()
                this.formData.settleStandardBatchDTO.smallCategoryIds = temp.join(';')
              } else {
                this.$message.warning('请选择产品类型')
                return
              }

            }

            if (this.itemList != null && this.itemList.length !== 0) {
              this.itemIdList = []
              this.itemList.forEach(item => {
                this.itemIdList.push(item.id)
              })
              let temp = this.itemIdList.sort()
              this.formData.settleStandardBatchDTO.itemIds = temp.join(';')
            }

            if (this.siteName != null && this.siteName.length !== 0) {
              this.siteIdList = []
              this.siteName.forEach(item => {
                this.siteIdList.push(item.id)
              })
              let temp = this.siteIdList.sort()
              this.formData.settleStandardBatchDTO.siteIds = temp.join(';')
            }

            if (this.selectSiteTypeOption != null && this.selectSiteTypeOption.length !== 0) {
              let temp = this.selectSiteTypeOption.sort()
              this.formData.settleStandardBatchDTO.siteTypeIds = temp.join(';')
            }

            console.log("this.formData.settleStandardBatchDTO--->",this.formData.settleStandardBatchDTO);
            console.log("this.formData--->",this.formData);
            this.$mask.open()

            this.$http({
              url: this.isEdit ? this.addsDataUrl : this.addsDataUrl,
              method: `post`,
              data: this.formData.settleStandardBatchDTO,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              this.$emit('editViewDataUpdate')
              this.$baseReload()
              this.$mask.close()

            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
              this.$mask.close()

            })
          })
        }
      })
    },

    setListData(data) {
      if (data.sfSpecialFeeSubjectConditionDTO.brandId != null) {
        this.selectedBrandIdList = data.sfSpecialFeeSubjectConditionDTO.brandId.split(';')
      }
      if (data.sfSpecialFeeSubjectConditionDTO.smallCategoryId != null) {
        this.selectedItemCategoryIdList = data.sfSpecialFeeSubjectConditionDTO.smallCategoryId.split(';')
      }
      if (data.sfSpecialFeeSubjectConditionDTO.serverTypeId != null) {
        this.selectedServiceTypeIdList = data.sfSpecialFeeSubjectConditionDTO.serverTypeId.split(';')
      }
      if (data.sfSpecialFeeSubjectConditionDTO.guaranteeType != null) {
        let list = data.sfSpecialFeeSubjectConditionDTO.guaranteeType.split(';')
        this.selectedGuaranteeTypeIdList = []
        list.forEach(item => {
          this.selectedGuaranteeTypeIdList.push(Number(item))
        })
        this.formData.guaranteeTypeList = [{id: '1', type: '保内'}, {id: '2', type: '保外'}]
      }

      if (data.sfSpecialFeeSubjectConditionDTO.itemId != null && data.sfSpecialFeeSubjectConditionDTO.itemId != '') {
        let list = data.sfSpecialFeeSubjectConditionDTO.itemId.split(';');
        this.$http({
          url: api.basItem.getDataByIdsUrl,
          method: 'post',
          data: {ids: list}
        }).then(res => {
          let list = res.data.data
          if (list != null && list.length !== 0) {
            this.itemList = []
            list.forEach(item => {
              this.itemList.push({id: item.id, name: item.itemName})
            })
          }
        })
      }
    }

  },
};

</script>
<style lang="scss" scoped>
// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

.current-info {
  margin-left: 5px;
  margin-right: 5px;
}

.item-button {
  margin-bottom: 5px;
  text-align: right;
}

/*滚动条整体部分*/
.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*滚动条的轨道*/
.mytable-scrollbar ::-webkit-scrollbar-track {
  background-color: #FFFFFF;
}

/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #F1F1F1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
  background-color: #A8A8A8;
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}

/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
  background-color: #FFFFFF;
}


::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

.btn_zdy {
  // margin: 5px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

#containt .detail-wrap .d-cont .d-item:last-child {
  margin-bottom: 0px !important;
}

.current-date-picker {
  width: 15vw;
  border-radius: 2px;
  border-color: #e8e8e8;
  padding: 0 24px 0 8px;
  height: 28px !important;
  line-height: 28px;
}

.current-date-picker {
  // width: 85%!important;
  border-radius: 2px;
  border-color: #e8e8e8;
  padding: 0 0px 0 8px !important;
  height: 28px !important;
  line-height: 28px;
}
</style>
